import { useTheme } from '../../hooks/useTheme';

export function useIsSunriseTheme(): boolean {
	return !!useTheme().colors.sunrise;
}
